import { render } from "./AccontDeletion.vue?vue&type=template&id=489a652d&scoped=true"
import script from "./AccontDeletion.vue?vue&type=script&lang=js"
export * from "./AccontDeletion.vue?vue&type=script&lang=js"

import "./AccontDeletion.vue?vue&type=style&index=0&id=489a652d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489a652d"]])

export default __exports__